import fetchData from '../api.js';


export const sendPrintJob = async (order_id, UserStore, type = 1) => {

    let postData = {}; 
    postData.action = 'crm_print_order';   
    postData.token = UserStore.data;
    postData.order_id = order_id;
    let response = await fetchData(postData);
    console.log(response);
    if (response.data) {

    }

    return true;

    
};